import {Dispatch, SetStateAction, useState} from 'react';
import CustomRadio from '../../../../components/mazraeKit/customRadio';
import CancelLoanConfirmModal from '../../../lendtech/receiveCredit/cancelLoanRequest/CancelLoanConfirmModal';
import {
  getLoanCardHeaderStatus,
  getLoanStatusBadge,
  LoanRequestStatus,
  showCancelButtonByLoanStatus,
} from '../consts/loanStatus';
import {
  baseBadgeClassName,
  greenBadgeStyles,
  redBadgeStyles,
} from '../helper/getCashBackBadge';
import {CurrentTabStateTypes} from '../helper/getCurrentTabState';

interface IProps {
  loan: ILoanRequestItem;
  isSelected: boolean;
  setSelectedLoanGuid: Dispatch<SetStateAction<string>>;
  currentTabState: CurrentTabStateTypes;
  allCurrentLoansLength: number;
}

const InProgressLoanCard = ({
  loan,
  isSelected,
  setSelectedLoanGuid,
  currentTabState,
  allCurrentLoansLength,
}: IProps) => {
  const [isCancelModalOpen, setIsCancelModalOpen] = useState<boolean>(false);
  const isLoanCompleted = loan.status === LoanRequestStatus.COMPLETED;

  const isLoanTypeNotSelected =
    loan.status === LoanRequestStatus.SUBMITTED ||
    loan.status === LoanRequestStatus.PENDING_VALIDATION ||
    loan.status === LoanRequestStatus.FINISHED_VALIDATION ||
    loan.status === LoanRequestStatus.PENDING_LOAN_TYPE;

  const isLoanInSettlement =
    isLoanCompleted && loan.is_direct && !loan.is_paid_in_bank;

  const showCheckBox =
    currentTabState !== CurrentTabStateTypes.LoanRequestsOnly ||
    allCurrentLoansLength > 0;

  const badgeColor = () => {
    switch (true) {
      case isLoanCompleted || isLoanInSettlement:
        return baseBadgeClassName + ' ' + greenBadgeStyles;

      default:
        return baseBadgeClassName + ' ' + redBadgeStyles;
    }
  };

  const toggleLoanCard = () => {
    setSelectedLoanGuid(prev => (prev === loan.guid ? '' : loan.guid));
  };

  if (isLoanTypeNotSelected)
    return (
      <div
        id={loan.guid}
        className="flex min-h-[120px] gap-2 p-3 border-[1px] rounded-2xl border-gray-100 bg-gray-50 items-start"
        onClick={toggleLoanCard}
      >
        {showCheckBox && (
          <CustomRadio
            title=""
            inputClassname="size-4 mt-0.5"
            value={loan.guid}
            checked={isSelected}
            onChange={toggleLoanCard}
            onClick={e => e.stopPropagation()}
            name="loan"
          />
        )}

        <div className="flex flex-col w-full gap-10">
          <div className="flex items-center gap-2 text-gray-900">
            <i className="text-xl icon-money-bag" />
            <span className="text-sm font-medium">
              {getLoanCardHeaderStatus(loan.status)}
            </span>
            {showCancelButtonByLoanStatus(
              loan?.status as LoanRequestStatus,
            ) && (
              <i
                className="mr-auto text-xl text-red-500 icon-nameDelete"
                onClick={e => {
                  e.stopPropagation();
                  setIsCancelModalOpen(true);
                }}
              />
            )}
          </div>

          <div className={badgeColor()}>{getLoanStatusBadge(loan.status)}</div>
        </div>

        <CancelLoanConfirmModal
          isOpen={isCancelModalOpen}
          setIsOpen={setIsCancelModalOpen}
          loanGuid={loan?.guid}
          title="لغو درخواست"
          confirmationText="از لغو درخواست وام اطمینان دارید؟"
          removeText="لغو درخواست"
          shouldRedirect={false}
          onDelete={() => setSelectedLoanGuid('')}
        />
      </div>
    );

  return (
    <div
      id={loan.guid}
      className="flex min-h-[120px] gap-2 p-3 border-[1px] rounded-2xl border-gray-100 bg-gray-50 items-start"
      onClick={toggleLoanCard}
    >
      {showCheckBox && (
        <CustomRadio
          title=""
          inputClassname="size-4"
          value={loan.guid}
          checked={isSelected}
          onChange={toggleLoanCard}
          onClick={e => e.stopPropagation()}
          name="loan"
        />
      )}
      <div className="flex flex-col w-full gap-2">
        <div className="flex items-center gap-2 text-gray-900">
          <img src={loan?.bank_logo} className={`object-contain w-5 h-5`} />
          <span className="text-sm font-medium">{loan?.bank_title}</span>
          {showCancelButtonByLoanStatus(loan?.status as LoanRequestStatus) && (
            <i
              className="mr-auto text-lg text-red-500 icon-nameDelete"
              onClick={e => {
                e.stopPropagation();
                setIsCancelModalOpen(true);
              }}
            />
          )}
        </div>
        <div className="flex items-center gap-1 mb-1">
          <span className="font-medium text-gray-800 text-md">
            {loan.loan_type_amount?.toLocaleString()}
          </span>
          <span className="text-sm font-normal text-gray-700 ">تومان</span>
        </div>
        <div className={badgeColor()}>
          {isLoanInSettlement ? 'دریافت شده' : getLoanStatusBadge(loan.status)}
        </div>
      </div>
      <CancelLoanConfirmModal
        isOpen={isCancelModalOpen}
        setIsOpen={setIsCancelModalOpen}
        loanGuid={loan?.guid}
        title="لغو درخواست"
        confirmationText="از لغو درخواست وام اطمینان دارید؟"
        removeText="لغو درخواست"
        shouldRedirect={false}
        onDelete={() => setSelectedLoanGuid('')}
      />
    </div>
  );
};

export default InProgressLoanCard;
